import { SpecificationInfo } from './specification-info';
import { Label } from './label/label';
import { SpecificationType } from './enums';

export class SpecificationVersionInfo {
    id: number;
    name: string;
    specificationType: SpecificationType;
    specification: SpecificationInfo;
    releaseStatus: number;
    labels: Label[];
}
